import router from '@/router'
import { AppSidebar, AppHeader } from '@/components'
import FooterOutgoingLinks from '@/components/FooterOutgoingLinks.vue'
import { allowOnlyWithCompletedJourney } from '@/router/routerGuards'

export const routes = [
  {
    path: '/dashboard',
    name: 'dashboard',
    components: {
      default: () => import('./dashboard.vue'),
      sidebar: AppSidebar,
      header: AppHeader,
      footer: FooterOutgoingLinks
    },
    meta: {
      documentTitle: 'Home',
      sitemap: {
        title: 'Welcome to your Swoop Portal!',
        description: "User's main overview and metrics"
      },
      permissions: {
        roles: ['user'],
        redirectTo: {
          name: 'login'
        }
      }
    },
    beforeEnter: allowOnlyWithCompletedJourney()
  }
]

export default () => {
  routes.forEach(route => router.addRoute(route))
}
